/** Global Components
 * @author Virgilio Vázquez J. <virgilio.vazquez@jbge.com.mx>
 */

import NoContent from './components/NoContent'
import PrettyPrint from './components/PrettyPrint'
import ImageWithFallback from './components/ImageWithFallback.vue'
import KFileField from '@/components/Inputs/KFileField'
import KSeeMoreLess from '@/components/Inputs/KSeeMoreLess'

export default {
  install(Vue) {
    Vue.component('no-content', NoContent)
    Vue.component('pretty-print', PrettyPrint)
    Vue.component('img-safe', ImageWithFallback)
    Vue.component('KFileField', KFileField)
    Vue.component('KSeeMoreLess', KSeeMoreLess)
  }
}
